export default {"src":"/_next/static/media/alertai_icon_light.56b6f804.svg","height":166,"width":889,"blurWidth":0,"blurHeight":0};